<template>
  <div class="product-card" :class="{ inactive: !product.isActive }">
    <div class="card-header">
      <div class="icon-wrapper">
        <i :class="['fa-solid', productIcon]" />
      </div>
      <div class="header-info">
        <h3 class="product-name">{{ product.name }}</h3>
        <span class="product-type">{{ productTypeLabel }}</span>
      </div>
    </div>

    <div class="card-body">
      <!-- 설치비 -->
      <div class="fee-section">
        <div class="fee-label">설치비</div>
        <div class="fee-value">{{ formatCurrency(product.installationFee) }}</div>
      </div>

      <!-- 사용료 -->
      <div class="usage-fee-section">
        <div class="section-title">사용료</div>
        <div class="fee-grid">
          <div class="fee-item">
            <span class="fee-type">월간</span>
            <span class="fee-amount">{{ formatCurrency(product.usageFee?.monthly) }}</span>
          </div>
          <div class="fee-item">
            <span class="fee-type">연간</span>
            <span class="fee-amount">{{ formatCurrency(product.usageFee?.yearly) }}</span>
          </div>
          <div class="fee-item">
            <span class="fee-type">일회성</span>
            <span class="fee-amount">{{ formatCurrency(product.usageFee?.oneTime) }}</span>
          </div>
          <div class="fee-item">
            <span class="fee-type">건당</span>
            <span class="fee-amount">{{ formatCurrency(product.usageFee?.perTransaction) }}</span>
          </div>
        </div>
      </div>

      <!-- 설명 -->
      <div class="description-section" v-if="product.description">
        <div class="description-text">{{ product.description }}</div>
      </div>
    </div>

    <div class="card-footer">
      <a-button type="primary" class="edit-button" @click="handleEdit">
        <i class="fa-regular fa-pen-to-square" />
        수정
      </a-button>
    </div>
  </div>
</template>

<script>
import { SystemProductTypeLabel, SystemProductTypeIcon } from '../enums';

export default {
  name: 'ProductCard',
  props: {
    product: {
      type: Object,
      required: true,
    },
  },
  emits: ['edit'],
  computed: {
    productTypeLabel() {
      return SystemProductTypeLabel[this.product.type] || this.product.type;
    },
    productIcon() {
      return SystemProductTypeIcon[this.product.type] || 'fa-box';
    },
  },
  methods: {
    formatCurrency(value) {
      if (value === undefined || value === null) return '₩ 0';
      return `₩ ${Number(value).toLocaleString()}`;
    },
    handleEdit() {
      this.$emit('edit', this.product);
    },
  },
};
</script>

<style lang="scss" scoped>
.product-card {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  overflow: hidden;
  transition: all 0.3s ease;
  height: 100%;
  display: flex;
  flex-direction: column;

  &:hover {
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
    transform: translateY(-2px);
  }

  &.inactive {
    opacity: 0.6;
  }
}

.card-header {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 20px;
  background: linear-gradient(135deg, #ffeaa7 0%, #ffe414 100%);
}

.icon-wrapper {
  width: 56px;
  height: 56px;
  background: rgba(255, 255, 255, 0.9);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;

  i {
    font-size: 24px;
    color: #17191c;
  }
}

.header-info {
  flex: 1;
}

.product-name {
  margin: 0;
  font-size: 20px;
  font-weight: 700;
  color: #17191c;
}

.product-type {
  font-size: 13px;
  color: rgba(23, 25, 28, 0.7);
}

.card-body {
  flex: 1;
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.fee-section {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  background: #f8f9fa;
  border-radius: 8px;
}

.fee-label {
  font-size: 14px;
  color: #666;
  font-weight: 500;
}

.fee-value {
  font-size: 18px;
  font-weight: 700;
  color: #17191c;
}

.usage-fee-section {
  .section-title {
    font-size: 14px;
    font-weight: 600;
    color: #17191c;
    margin-bottom: 12px;
  }
}

.fee-grid {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.fee-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 12px;
  background: #f8f9fa;
  border-radius: 6px;

  .fee-type {
    font-size: 13px;
    color: #888;
  }

  .fee-amount {
    font-size: 14px;
    font-weight: 600;
    color: #17191c;
  }
}

.description-section {
  padding-top: 12px;
  border-top: 1px solid #f0f0f0;

  .description-text {
    font-size: 14px;
    color: #666;
    line-height: 1.5;
  }
}

.card-footer {
  padding: 16px 20px;
  border-top: 1px solid #f0f0f0;
}

.edit-button {
  width: 100%;
  height: 40px;
  background: #ffe414 !important;
  border-color: #ffe414 !important;
  color: #17191c !important;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;

  &:hover {
    background: #ffd900 !important;
    border-color: #ffd900 !important;
  }

  i {
    font-size: 14px;
  }
}
</style>
